// Trading Dashboard Chart Component
export default {
  // Title
  trendTitle: "Transfer In/Out Trend",

  // Amount Statistics
  transferInAmount: "Transfer In Amount:",
  transferOutAmount: "Transfer Out Amount:",
  tenThousand: "10k",

  // Time Period Options
  currentWeek: "This Week",
  currentMonth: "This Month",
  halfYear: "Half Year",
  currentYear: "This Year",

  // Date Picker
  startDate: "Start Date",
  endDate: "End Date",

  // Chart Configuration
  unit: "Unit: (10k)",
  transferInSeries: "Transfer In",
  transferOutSeries: "Transfer Out",
};
